import type { bankingApiSpec } from "@wingspanhq/wingspan-api-types";

export const selectorPendingBankingAccount = (
  internalAccount: bankingApiSpec.InternalAccount
): boolean =>
  internalAccount.type === "Banking" && internalAccount.status === "Pending";
